// War Ledger arithmetic (GDD §6, §10) shared by the HUD ledger panel and the war report.

import type { PlayerPrivateState } from '@taxwar/net'

export type Ledger = PlayerPrivateState['ledger']

/** Everything this war cost the treasury: the national debt the war report bills (GDD §10). */
export function warSpend(ledger: Ledger): number {
  return ledger.spentUnits + ledger.spentBuildings + ledger.spentStrikes
}

/** Total spend per city captured; null while no city has been captured. */
export function costPerCityCaptured(ledger: Ledger): number | null {
  return ledger.citiesCaptured === 0 ? null : warSpend(ledger) / ledger.citiesCaptured
}
